/**
 * The two sentences that tell a student whether a teacher has been through a Writing or Speaking band. This file is the only
 * place either sentence is written: every page reads them from here (`reviewLine` and `sectionReviewLine` in `student-status.ts`).
 *
 * Wording is pending Dana (19 Oct 2026). To change it, change the English here and the matching key in `src/locales/ar.json`;
 * `catalog.test.ts` reads `REVIEW_LINE_COPY` and fails until the Arabic catalogue carries both.
 *
 * What decides which one shows is the server's own label, never a guess from bands or dates: `score_status` on a section,
 * `band_status` on the result (`indicative` until an examiner or teacher has stood behind the band, `confirmed` after).
 * The first sentence also needs `review_pending`: a declined, dismissed or superseded review stays `indicative` for good, and no
 * Writing review can be decided again, so that band shows the Indicative pill alone and never promises a teacher.
 */

/** An AI band still waiting for a teacher (server `score_status` / `band_status` = `indicative` and `review_pending` = true). */
export const INDICATIVE_LINE = 'Indicative: a teacher may still adjust this band'

/** A band a teacher confirmed or corrected (server `confirmed`; `band_changed_on_review` says which). */
export const REVIEWED_LINE = 'Published after teacher review'

/** Every English string above, so the Arabic catalogue test sees them. */
export const REVIEW_LINE_COPY: readonly string[] = [INDICATIVE_LINE, REVIEWED_LINE]
